{
  "fr": {
    "models": {
      "image": {
        "background": "Utiliser comme fond ?",
        "enabled": "Activé ?",
        "global": "Global ?",
        "delete": "Supprimer",
        "start": "Démarrer",
        "cancel": "Annuler",
        "processing": "Traitement...",
        "error": "Erreur",
        "name": "Nom",
        "size": "Taille du fichier",
        "dropzone": "Déposez les images ici"
      }
    }
  }
}
